import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import {label} from './Dictionary.js';

function LiveStatus({isLoading, isNeedsWake, onWakeDialogClick=()=>{}}) {

    const loadingProgressStyle = {
        color: "rgb(255,255,255)"
    }

    return (
        <>
          <Backdrop
            sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
            open={isNeedsWake}
            onClick={onWakeDialogClick}
            >
            <Card sx={{ maxWidth: 445 }}>
            <CardMedia
                sx={{ height: 300 }}
                image="/wake_button.jpg"
                title="wake"
            />
            <CardContent>
            <Typography gutterBottom variant="h5" component="div">
            {label("ID_WakeDevice")}
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                {label("ID_WakeMessage1")}
                <br/><br/>
                {label("ID_WakeMessage2")}
            </Typography>
            </CardContent>
            </Card>

        </Backdrop>
        <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={isLoading}
            //  onClick={()=>{setLoading(false)}}
                >
        <CircularProgress size="51px" sx={loadingProgressStyle}/>
        </Backdrop>
        </>
    );

}

export default LiveStatus;